(function () {
  const CALENDAR_I18N = {
    daysOfWeek: ['Lun', 'Mar', 'Mer', 'Gio', 'Ven', 'Sab', 'Dom'],
    months: [
      'Gennaio',
      'Febbraio',
      'Marzo',
      'Aprile',
      'Maggio',
      'Giugno',
      'Luglio',
      'Agosto',
      'Settembre',
      'Ottobre',
      'Novembre',
      'Dicembre',
    ],
  };

  const mqMobile = window.matchMedia('(max-width: 768px)');

  function initCalendar(root) {
    if (!root || root.dataset.inited === '1') return;
    root.dataset.inited = '1';

    const RESULTS_URL = root.dataset.searchUrl || '/search';

    const monthGrid = root.querySelector('[data-month-grid]');
    const calendarContainer = root.querySelector('[data-calendar-container]');
    const prevBtn = root.querySelector('[data-prev-month]');
    const nextBtn = root.querySelector('[data-next-month]');
    const confirmBtn = root.querySelector('[data-confirm]');

    let currentMonth = new Date().getMonth();
    let currentYear = new Date().getFullYear();

    let selectedStartDate = null;
    let selectedEndDate = null;

    function createMonthGrid(year, month) {
      const firstDay = new Date(year, month, 1);
      const monthLabel = CALENDAR_I18N.months[month] || firstDay.toLocaleString('default', { month: 'long' });

      const totalDays = new Date(year, month + 1, 0).getDate();
      const startDay = (firstDay.getDay() + 6) % 7;

      let html = '<div class="calendar-grid">';
      CALENDAR_I18N.daysOfWeek.forEach((d) => (html += `<div class="calendar-day">${d}</div>`));
      html += '</div><div class="calendar-grid-date">';

      const cells = [];
      for (let i = 0; i < startDay; i++) cells.push('<div class="calendar-date empty"></div>');

      for (let day = 1; day <= totalDays; day++) {
        cells.push(
          `<div class="calendar-date" data-year="${year}" data-month="${month}" data-day="${day}">${day}</div>`
        );
      }

      while (cells.length % 7 !== 0) cells.push('<div class="calendar-date empty"></div>');

      for (let i = 0; i < cells.length; i += 7) {
        html += `<div class="calendar-week-row">${cells.slice(i, i + 7).join('')}</div>`;
      }

      html += '</div>';

      return `
        <div class="calendar-month" data-year="${year}" data-month="${month}">
          <div class="month-header">${monthLabel} ${year}</div>
          ${html}
        </div>
      `;
    }

    function resetDateSelection() {
      root.querySelectorAll('.calendar-date').forEach((el) => {
        el.classList.remove('selected-start', 'selected-end', 'in-range', 'single-selected');
      });
    }

    function updateSelectedDatesUI() {
      const dates = root.querySelectorAll('.calendar-date');
      const hasEnd = selectedStartDate && selectedEndDate;

      dates.forEach((el) => {
        if (el.classList.contains('empty')) return;

        const day = parseInt(el.dataset.day, 10);
        const year = parseInt(el.dataset.year, 10);
        const monthIndex = parseInt(el.dataset.month, 10);
        const dateObj = new Date(year, monthIndex, day);

        el.classList.remove('selected-start', 'selected-end', 'in-range', 'single-selected');

        if (!selectedStartDate) return;

        const start = new Date(selectedStartDate);
        const end = selectedEndDate ? new Date(selectedEndDate) : null;

        if (!hasEnd) {
          if (dateObj.getTime() === start.getTime()) el.classList.add('single-selected');
          return;
        }

        if (dateObj.getTime() === start.getTime()) el.classList.add('selected-start');
        else if (dateObj.getTime() === end.getTime()) el.classList.add('selected-end');
        else if (dateObj > start && dateObj < end) el.classList.add('in-range');
      });
    }

    function handleDateClick(clickedEl) {
      if (!clickedEl.classList.contains('calendar-date') || clickedEl.classList.contains('empty')) return;

      const day = parseInt(clickedEl.dataset.day, 10);
      const year = parseInt(clickedEl.dataset.year, 10);
      const monthIndex = parseInt(clickedEl.dataset.month, 10);
      const clickedDate = new Date(year, monthIndex, day);

      if (!selectedStartDate || (selectedStartDate && selectedEndDate)) {
        selectedStartDate = clickedDate;
        selectedEndDate = null;
      } else if (!selectedEndDate) {
        if (clickedDate < selectedStartDate) {
          selectedEndDate = selectedStartDate;
          selectedStartDate = clickedDate;
        } else {
          selectedEndDate = clickedDate;
        }
      }

      resetDateSelection();
      updateSelectedDatesUI();
    }

    function generateCalendar() {
      if (!calendarContainer) return;

      const isMobile = mqMobile.matches;
      const firstMonth = createMonthGrid(currentYear, currentMonth);

      if (isMobile) {
        calendarContainer.innerHTML = firstMonth;
      } else {
        const nextMonth = createMonthGrid(currentMonth === 11 ? currentYear + 1 : currentYear, (currentMonth + 1) % 12);
        calendarContainer.innerHTML = firstMonth + nextMonth;
      }

      updateSelectedDatesUI();
    }

    function generateMonths() {
      if (!monthGrid) return;

      const today = new Date();
      const months = [];
      for (let i = 0; i < 12; i++) {
        const date = new Date(today.getFullYear(), today.getMonth() + i, 1);
        months.push({
          label: `${CALENDAR_I18N.months[date.getMonth()]} ${date.getFullYear()}`,
          year: date.getFullYear(),
          month: date.getMonth(),
        });
      }

      monthGrid.innerHTML = months
        .map(
          (m) => `<div class="month-item" data-year="${m.year}" data-month="${m.month}">
                    <div class="calendar-month-name-year">${m.label}</div>
                  </div>`
        )
        .join('');
    }

    function formatDateParam(date) {
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      return `${y}-${m}-${d}`;
    }

    root.addEventListener('click', (e) => {
      const tabBtn = e.target.closest('.tab-button[data-tab]');
      if (tabBtn) {
        const targetTab = tabBtn.dataset.tab;

        root.querySelectorAll('.tab-button[data-tab]').forEach((b) => b.classList.remove('active'));
        root.querySelectorAll('.tab-content[data-tab-content]').forEach((t) => t.classList.remove('active'));

        tabBtn.classList.add('active');
        root.querySelector(`[data-tab-content="${targetTab}"]`)?.classList.add('active');
        return;
      }

      if (e.target.closest('[data-prev-month]')) {
        if (currentMonth === 0) {
          currentMonth = 11;
          currentYear--;
        } else currentMonth--;
        generateCalendar();
        return;
      }

      if (e.target.closest('[data-next-month]')) {
        if (currentMonth === 11) {
          currentMonth = 0;
          currentYear++;
        } else currentMonth++;
        generateCalendar();
        return;
      }

      const dateEl = e.target.closest('.calendar-date');
      if (dateEl) {
        handleDateClick(dateEl);
        return;
      }

      const monthItem = e.target.closest('.month-item');
      if (monthItem) {
        const year = parseInt(monthItem.dataset.year, 10);
        const month = parseInt(monthItem.dataset.month, 10);

        const start = new Date(year, month, 1);
        const end = new Date(year, month + 1, 0);

        window.location.href = `${RESULTS_URL}?start=${formatDateParam(start)}&end=${formatDateParam(end)}`;
        return;
      }

      if (e.target.closest('[data-confirm]')) {
        if (selectedStartDate && selectedEndDate) {
          window.location.href = `${RESULTS_URL}?start=${formatDateParam(selectedStartDate)}&end=${formatDateParam(
            selectedEndDate
          )}`;
        } else {
          alert('Seleziona start e end.');
        }
      }
    });

    // init
    generateMonths();
    generateCalendar();

    // se cambia breakpoint, aggiorna 1 mese / 2 mesi
    mqMobile.addEventListener?.('change', generateCalendar);
  }

  function initAllCalendars() {
    document.querySelectorAll('[data-calendar-filter]').forEach(initCalendar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCalendars);
  } else {
    initAllCalendars();
  }

  window.initAllCalendars = initAllCalendars;
})();
